import LeftGroupList from "@/components/LeftGroupList";
import ButtonDialog from "@/components/ButtonDialog";
import api from "@/api";
import LogicalReasoning2DQuestion from "@/components/subject/LogicalReasoning2d/LogicalReasoning2DQuestion.vue";
export default {
  name: "Logical2DQuestionView",
  components: {
    LogicalReasoning2DQuestion,
    LeftGroupList,
    ButtonDialog
  },
  data() {
    return {
      groups: [],
      groupId: null,
      questions: []
    };
  },
  methods: {
    deleteGroup() {
      api.deleteLogical2dGroup(this.groupId).then(() => {
        this.init();
      });
    },
    deleteLogicalQuestion(qid) {
      api.deleteLogical2dQuestion(qid).then(() => {
        this.fetchList();
      });
    },
    onChoose(gid) {
      this.groupId = gid;
      this.fetchList();
    },
    fetchList() {
      api.getLogical2dQuestionByGroupId(this.groupId).then(ret => {
        this.questions = ret.list;
      });
    },
    init() {
      api.getLogical2dGroups().then(list => {
        this.groups = list;
        this.groupId = list[0].value;
        this.fetchList();
      });
    }
  },
  mounted() {
    this.init();
  }
};